// 自定义方法
let exports = {}
exports.install = function (Vue, options) {
  Vue.prototype._get_login = function (){
    const user_id = localStorage.getItem('user_id')
    const token = localStorage.getItem('token')
    if (token === null || token === '' || user_id === null || user_id === '') {
      return {code:5001,data:{},message:'用户未登录'}
    }else{
      return {code:200,data:{user_id:user_id,token:token},message:'登录'}
    }
  }
  Vue.prototype._random_color = function (x){
    if (x!==undefined)
      return "rgba("+x+","+(256-x)+","+x+",0.5)"
    return "rgba("+Math.floor(Math.random()*256)+","+Math.floor(Math.random()*256)+","+Math.floor(Math.random()*256)+",0.5)"
  }
  Vue.prototype._get_product_name = function(product_id,product_list,is_icon=false){
    if (product_id){
      let product_item = product_list.find(function (el,i) {
        return el.id===product_id
      })
      if (is_icon)
        return product_item?product_item.icon:''
      if (product_id == '总计')
        return product_id
      return product_item?product_item.name:'关停产品'+product_id
    }else{
      if (is_icon)
        return '/uploads/user_thumb/no_p.gif'
      return '通用'
    }
  }
  Vue.prototype._get_generate_type = function(type){
    switch (type) {
      case 1:
        return '模板生成'
      case 2:
        return '手动上传'
      case 3:
        return '尺寸生成'
      case 4:
        return '高斯生成'
      case 5:
        return '语言生成'
      case 6:
        return '滤镜生成'
      case 7:
        return '画中画生成'
      case 8:
        return '批量'
      case 9:
        return '场景'
      case 10:
        return 'End Card'
    }
  }
  Vue.prototype._get_tags_name = function(tags_id,tags_list){
    if (tags_id){
      let tags_item = tags_list.find(function (el,i) {
        return Number(el.id)===Number(tags_id)
      })
      return tags_item?tags_item.name:'关停标签'+tags_item
    }else{
      return '通用'
    }
  }
  Vue.prototype._get_language_name = function(language,language_list){
    if (language){
      let language_item = language_list.find(function (el,i) {
        return el.value===language
      })
      return language_item!==undefined?language_item.name:"通用"
    }else{
      return '通用';
    }
  }
  Vue.prototype._get_push_channel_info = function(channel_id,push_channel_list){
    if (channel_id){
      let channel_info = push_channel_list.find(function (el,i) {
        return el.value===channel_id
      })
      return channel_info
    }else{
      return {};
    }
  }
  Vue.prototype._set_login = function (user_id,token){
    localStorage.setItem('user_id',user_id)
    localStorage.setItem('token',token)
    return true
  }
  Vue.prototype._get_init_menu = function (menu=[],out_menu=[],key=1,now_menu={},now = true){//全局函数2
    for (var i in menu){
      now_menu[key] = menu[i].id
      if (menu[i].url!==""){
        let _now_menu = {}
        for (var a in now_menu){
          _now_menu[a] = now_menu[a]
        }
        out_menu.push({url:menu[i].url,component:menu[i].component,now_menu:_now_menu,child:menu[i].child})
      }
      if (menu[i].child){
        out_menu = this._get_init_menu(menu[i].child,out_menu,key+1,now_menu,now)
      }
    }
    return out_menu
  }
  Vue.prototype._date_to_format_a = function(date,fmt) {
    var o = {
      "M+" : date.getMonth()+1,                 //月份
      "d+" : date.getDate(),                    //日
      "h+" : date.getHours(),                   //小时
      "m+" : date.getMinutes(),                 //分
      "s+" : date.getSeconds(),                 //秒
      "q+" : Math.floor((date.getMonth()+3)/3), //季度
      "S"  : date.getMilliseconds()             //毫秒
    };
    if(/(y+)/.test(fmt)) {
      fmt=fmt.replace(RegExp.$1, (date.getFullYear()+"").substr(4 - RegExp.$1.length));
    }
    for(var k in o) {
      if(new RegExp("("+ k +")").test(fmt)){
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));
      }
    }
    return fmt;
  }
  Vue.prototype._time_to_format_a = function (time, cFormat) {
    if (arguments.length === 0) {
      return null
    }
    const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
    let date
    if (typeof time === 'object') {
      date = time
    } else {
      if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
        time = parseInt(time)
      }
      if ((typeof time === 'number') && (time.toString().length === 10)) {
        time = time * 1000
      }
      date = new Date(time)
    }
    const formatObj = {
      y: date.getFullYear(),
      m: date.getMonth() + 1,
      d: date.getDate(),
      h: date.getHours(),
      i: date.getMinutes(),
      s: date.getSeconds(),
      a: date.getDay()
    }
    const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
      let value = formatObj[key]
      // Note: getDay() returns 0 on Sunday
      if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value ] }
      if (result.length > 0 && value < 10) {
        value = '0' + value
      }
      return value || 0
    })
    return time_str
  }
}
export default exports;




// WEBPACK FOOTER //
// ./src/utils/my_action.js